// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__Tam1R","buttonLoader":"Button_buttonLoader__bFWJX"};